import Api from '../api'
export default ({
  state: {
    fixedAssetsMaxSalesOrderNumber: null,
    fixedAssetsMaxSalesChallanNumber: null,
    fixedAssetsMaxSalesInvoiceNumber: null,
    fixedAssetsMaxPurchaseReturnNumber: null,
    fixedAssetsSalesChallanLists: [],
    fixedAssetsSalesOrderLists: [],
    fixedAssetsSalesInvoiceVoidLists: [],
    fixedAssetsSalesReturnLists: [],
    fixedAssetsInventoryOutDetailList: [],
    fixedAssetsSalesInvoiceLists: []
  },
  mutations: {
    FIXEDASSETS_MAX_SALES_ORDER_NUMBER(state, fixedAssetsMaxSalesOrderNo) {
      state.fixedAssetsMaxSalesOrderNumber = fixedAssetsMaxSalesOrderNo
    },
    FIXEDASSETS_MAX_SALES_CHALLAN_NUMBER(state, fixedAssetsMaxSalesChallanNo) {
      state.fixedAssetsMaxSalesChallanNumber = fixedAssetsMaxSalesChallanNo
    },
    FIXEDASSETS_MAX_SALES_INVOICE_NUMBER(state, fixedAssetsMaxSalesInvoiceNo) {
      state.fixedAssetsMaxSalesInvoiceNumber = fixedAssetsMaxSalesInvoiceNo
    },
    FIXEDASSETS_MAX_PURCHASE_RETURN_NUMBER(state, fixedAssetsMaxPurchaseReturnNo) {
      state.fixedAssetsMaxPurchaseReturnNumber = fixedAssetsMaxPurchaseReturnNo
    },
    FIXEDASSETS_SALES_CHALLAN_LIST(state, fixedAssetsSalesChallanList) {
      state.fixedAssetsSalesChallanLists = fixedAssetsSalesChallanList
    },
    FIXEDASSETS_SALES_ORDER_LIST(state, fixedAssetsSalesOrderList) {
      state.fixedAssetsSalesOrderLists = fixedAssetsSalesOrderList
    },
    FIXEDASSETS_SALES_INVOICE_LIST(state, fixedAssetsSalesInvoiceList) {
      state.fixedAssetsSalesInvoiceLists = fixedAssetsSalesInvoiceList
    },
    FIXEDASSETS_SALES_INVOICE_VOID_LIST(state, fixedAssetsSalesInvoiceVoidList) {
      state.fixedAssetsSalesInvoiceVoidLists = fixedAssetsSalesInvoiceVoidList
    },
    FIXEDASSETS_DELETE_SALES_ORDER (state, salesOrder) {
      let inventoryOutHeader = state.salesOrderLists.filter(a => a.id !== salesOrder.id)
      state.salesOrderLists = inventoryOutHeader
    },
    FIXEDASSETS_DELETE_SALES_CHALLAN(state, salesChallan) {
      let fixedAssetsSalesChallanList = state.fixedAssetsSalesChallanLists.filter(a => a.id !== salesChallan.id)
      state.fixedAssetsSalesChallanLists = fixedAssetsSalesChallanList
    },
    FIXEDASSETS_DELETE_SALES_INVOICE(state, salesInvoice) {
      let fixedAssetsSalesInvoiceList = state.fixedAssetsSalesInvoiceLists.filter(a => a.id !== salesInvoice.id)
      state.fixedAssetsSalesInvoiceLists = fixedAssetsSalesInvoiceList
    },
    FIXEDASSETS_DELETE_SALES_RETURN(state, salesReturn) {
      let fixedAssetsSalesReturnList = state.fixedAssetsSalesReturnLists.filter(a => a.id !== salesReturn.id)
      state.fixedAssetsSalesReturnLists = fixedAssetsSalesReturnList
    },
    FIXEDASSETS_UPDATE_SALES_ORDER(state, salesOrder) {
      let fixedAssetsSalesOrderList = state.fixedAssetsSalesOrderLists.map(so => so.id !== salesOrder.id ? so : {...so, ...salesOrder})
      state.fixedAssetsSalesOrderLists = fixedAssetsSalesOrderList
    },
    FIXEDASSETS_UPDATE_SALES_INVOICE(state, salesInvoice) {
      let fixedAssetsSalesInvoiceList = state.fixedAssetsSalesInvoiceLists.map(salesInv => salesInv.id !== salesInvoice.id ? salesInv : {...salesInv, ...salesInvoice})
      state.fixedAssetsSalesInvoiceLists = fixedAssetsSalesInvoiceList
    },
    FIXEDASSETS_UPDATE_SALES_RETURN(state, salesReturn) {
      let fixedAssetsSalesReturnList = state.fixedAssetsSalesReturnLists.map(salesRet => salesRet.id !== salesReturn.id ? salesRet : {...salesRet, ...salesReturn})
      state.fixedAssetsSalesReturnLists = fixedAssetsSalesReturnList
    },
    FIXEDASSETS_UPDATE_SALES_CHALLAN(state, salesChallan) {
      let fixedAssetsSalesChallanList = state.fixedAssetsSalesChallanLists.map(salesChal => salesChal.id !== salesChallan.id ? salesChal : {...salesChal, ...salesChallan})
      state.fixedAssetsSalesChallanLists = fixedAssetsSalesChallanList
    },
    FIXEDASSETS_INVENTORY_OUT_DETAIL(state, inventoryOutDetail) {
      state.inventoryOutDetailList = inventoryOutDetail
    },
    FIXEDASSETS_SALES_RETURN_LIST(state, fixedAssetsSalesReturnList) {
      state.fixedAssetsSalesReturnLists = fixedAssetsSalesReturnList
    }
  },
  actions: {
    async fixedAssetsMaxSalesOrderNo({ commit }) {
      let response = await Api.request('get', '/fixedAssets/salesOrderLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('FIXEDASSETS_MAX_SALES_ORDER_NUMBER', responseValue)
      return response
    },
    async fixedAssetsMaxSalesInvoiceBillNo({ commit }) {
      let response = await Api.request('get', '/fixedAssets/salesInvoiceLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('FIXEDASSETS_MAX_SALES_INVOICE_NUMBER', responseValue)
      return response
    },
    async fixedAssetsMaxSalesChallanNo({ commit }) {
      let response = await Api.request('get', '/fixedAssets/salesChallanLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('FIXEDASSETS_MAX_SALES_CHALLAN_NUMBER', responseValue)
      return response
    },
    async fixedAssetsMaxPurchaseReturnNumber({ commit }) {
      let response = await Api.request('get', '/fixedAssets/purchaseReturnLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('FIXEDASSETS_MAX_PURCHASE_RETURN_NUMBER', responseValue)
      return response
    },
    async addFixedAssetsSalesOrder({commit}, salesOrder) {
      let response = await Api.request('post', '/fixedAssets/saveSalesOrder/' + this.state.organisationid + '/' + this.getters.userId, salesOrder)
      // let responseValue = response.data.data
      if (response.data.status === 'SUCCESS') {
        // commit('ADD_SALES_ORDER', responseValue)
      }
      return response
    },
    async addFixedAssetsSalesChallan({commit}, salesChallan) {
      let response = await Api.request('post', '/fixedAssets/saveSalesChallan/' + this.state.organisationid + '/' + this.getters.userId, salesChallan)
      // let responseValue = response.data.data
      if (response.data.status === 'SUCCESS') {
        // commit('ADD_SALES_CHALLAN', responseValue)
      }
      return response
    },
    async addFixedAssetsSalesInvoice({commit}, salesInvoice) {
      let response = await Api.request('post', '/fixedAssets/saveSalesInvoice/' + this.state.organisationid + '/' + this.getters.userId, salesInvoice)
      // let responseValue = response.data.data
      if (response.data.status === 'SUCCESS') {
        // commit('ADD_SALES_INVOICE', responseValue)
      }
      return response
    },
    async addFixedAssetsPurchaseReturn({commit}, purchaseReturn) {
      let response = await Api.request('post', '/fixedAssets/purchaseReturn/' + this.state.organisationid + '/' + this.getters.userId, purchaseReturn)
      // let responseValue = response.data.data
      if (response.data.status === 'SUCCESS') {
        // commit('ADD_PURCHASE_RETURN', responseValue)
      }
      return response
    },
    async updateSalesReturn({commit}, salesReturn) {
      let response = await Api.request('put', '/fixedAssets/updateSales/' + salesReturn.inventoryOutHeaderId + '/' + this.getters.userId, salesReturn)
      if (response.data.status === 'SUCCESS') {
        commit('FIXEDASSETS_UPDATE_SALES_RETURN', response.data.data)
      }
      return response
    },
    async loadFixedAssetsSalesChallanLists({ commit }, date) {
      let response = await Api.request('get', '/fixedAssetsReport/salesChallan/' + this.state.organisationid + '/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '/' + this.state.warehouseData.id + '')
      let responseValue = response.data.data
      commit('FIXEDASSETS_SALES_CHALLAN_LIST', responseValue)
      return response
    },
    async loadFixedAssetsSalesOrderLists({ commit }, date) {
      let response = await Api.request('get', '/fixedAssetsReport/salesOrder/' + this.state.organisationid + '/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '/' + this.state.warehouseData.id + '')
      let responseValue = response.data.data
      commit('FIXEDASSETS_SALES_ORDER_LIST', responseValue)
      return response
    },
    async loadFixedAssetsSalesInvoiceLists({ commit }, date) {
      let response = await Api.request('get', '/fixedAssetsReport/salesInvoice/' + this.state.organisationid + '/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '/' + this.state.warehouseData.id + '')
      let responseValue = response.data.data
      commit('SALES_INVOICE_LIST', responseValue)
      return response
    },
    async loadFixedAssetsSalesInvoiceVoidLists({ commit }, date) {
      let response = await Api.request('get', '/fixedAssetsReport/salesInvoiceVoid/' + this.state.organisationid + '/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '/' + this.state.warehouseData.id + '')
      let responseValue = response.data.data
      commit('FIXEDASSETS_SALES_INVOICE_VOID_LIST', responseValue)
      return response
    },
    async deleteFixedAssetsSalesOrder({commit}, deleteRea) {
      let response = await Api.request('delete', '/fixedAssets/deleteSales/' + deleteRea.inventoryOutHeaderId + '/' + this.getters.userId + '/' + deleteRea.deleteReason)
      let deleteSales = response.data.data
      commit('FIXEDASSETS_DELETE_SALES_ORDER', deleteSales)
      return response
    },
    async deleteFixedAssetsSalesChallan({commit}, deleteRea) {
      let response = await Api.request('delete', '/fixedAssets/deleteSales/' + deleteRea.inventoryOutHeaderId + '/' + this.getters.userId + '/' + deleteRea.deleteReason)
      let deleteSales = response.data.data
      commit('FIXEDASSETS_DELETE_SALES_CHALLAN', deleteSales)
      return response
    },
    async deleteFixedAssetsSalesInvoice({commit}, deleteRea) {
      let response = await Api.request('delete', '/fixedAssets/deleteSales/' + deleteRea.inventoryOutHeaderId + '/' + this.getters.userId + '/' + deleteRea.deleteReason)
      let deleteSales = response.data.data
      commit('FIXEDASSETS_DELETE_SALES_INVOICE', deleteSales)
      return response
    },
    async deleteFixedAssetsSalesReturn({commit}, deleteRea) {
      let response = await Api.request('delete', '/fixedAssets/deleteSales/' + deleteRea.inventoryOutHeaderId + '/' + this.getters.userId + '/' + deleteRea.deleteReason)
      let deleteSales = response.data.data
      commit('FIXEDASSETS_DELETE_SALES_RETURN', deleteSales)
      return response
    },
    async updateFixedAssetsSales({commit}, sales) {
      let resp = await Api.request('put', '/fixedAssets/updateSales/' + sales.inventoryOutheaderId + '/' + this.getters.userId, sales)
      commit('UPDATE_SALES', resp.data.data)
      return resp
    },
    async loadFixedAssetsOutInventoryDetail({commit}, id) {
      let response = await Api.request('get', '/fixedAssetsReport/inventoryOutDetail/' + this.getters.organisationId + '/' + this.getters.userId + '/' + id)
      if (response.data.status === 'SUCCESS') {
        commit('INVENTORY_OUT_DETAIL', response.data.data)
      }
      return response
    },
    async loadFixedAssetsSalesReturnLists({ commit }, date) {
      let response = await Api.request('get', '/fixedAssetsReportInventoryInReport/salesReturn/' + this.state.organisationid + '/' + this.getters.userId + '/' + date.fromDate + '/' + date.toDate + '')
      let responseValue = response.data.data
      commit('FIXEDASSETS_SALES_RETURN_LIST', responseValue)
      return response
    },
    async updateFixedAssetsSalesOrder({commit}, salesOrder) {
      let response = await Api.request('put', '/fixedAssets/updateSales/' + salesOrder.id + '/' + this.getters.userId, salesOrder)
      if (response.data.status === 'SUCCESS') {
        commit('FIXEDASSETS_UPDATE_SALES_ORDER', response.data.data)
      }
      return response
    },
    async updateFixedAssetsSalesInvoice({commit}, sales) {
      let response = await Api.request('put', '/fixedAssets/updateSales/' + sales.id + '/' + this.getters.userId, sales)
      if (response.data.status === 'SUCCESS') {
        commit('FIXEDASSETS_UPDATE_SALES_INVOICE', response.data.data)
      }
      return response
    },
    async updateFixedAssetsSalesChallan({commit}, salesChallan) {
      let response = await Api.request('put', '/fixedAssets/updateSales/' + salesChallan.id + '/' + this.getters.userId, salesChallan)
      if (response.data.status === 'SUCCESS') {
        commit('FIXEDASSETS_UPDATE_SALES_CHALLAN', response.data.data)
      }
      return response
    },
    async extraExpensesFixedAssetsSalesList({commit}, inventoryHeaderId) {
      let response = await Api.request('get', '/fixedAssetsReport/extraExpensesList/' + inventoryHeaderId)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async fixedAssetsSalesBillNumber({commit}) {
      let response = await Api.request('get', '/fixedAssets/billNumber/' + this.getters.organisationId)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async fixedAssetsSalesReturnBillWise({commit}, returnData) {
      let response = await Api.request('post', '/fixedAssets/salesReturn/' + returnData.inventoryHeaderId + '/' + this.getters.organisationId + '/' + this.getters.userId, returnData)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async fixedAssetsSalesReturnDetailList({commit}, billNo) {
      let response = await Api.request('get', '/fixedAssetsReport/salesDetailByBillNo/' + billNo + '/' + this.getters.organisationId + '/' + this.getters.userId + '/' + this.getters.fyId)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async loadFixedAssetsSalesOrderIdList({commit}) {
      let response = await Api.request('get', '/fixedAssets/orderNumber/' + this.getters.organisationId)
      return response
    },
    async loadFixedAssetsSalesChallanIdList({commit}) {
      let response = await Api.request('get', '/fixedAssets/challanNumber/' + this.getters.organisationId)
      return response
    },
    async loadDataWithFixedAssetsSalesOrderId({commit}, orderId) {
      let response = await Api.request('get', '/fixedAssetsReport/salesDetailByOrderNo/' + orderId + '/' + this.state.organisationid + '/' + this.state.user.id)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async loadDataWithFixedAssetsSalesChallanNo({commit}, challanNo) {
      let response = await Api.request('get', '/fixedAssetsReport/salesDetailByChallanNo/' + challanNo + '/' + this.state.organisationid + '/' + this.state.user.id)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/fixedAssetsSales.js